import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AppBar, Toolbar, Typography, Container, Box } from '@mui/material';
import ProtectedMessage from './components/ProtectedMessage';
import AddMessage from './components/AddMessage';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import puppyImage from './images/max.png';
import kittyImage from './images/oreo.png';
import './App.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#9370DB', // Lavender color
        },
    },
});

const AppLayout: React.FC = () => {
    return (
        <div className="App">
            <AppBar position="static" color="primary" className="App-header">
                <Toolbar>
                    <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
                        Welcome Earoland2!
                    </Typography>
                    <img src={puppyImage} alt="Puppy" className="header-image" />
                </Toolbar>
            </AppBar>
            <Container component="main" className="App-main">
                <Outlet />
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <img src={kittyImage} alt="Kitty" className="main-image" />
                </Box>
            </Container>
            <Box component="footer" className="App-footer">
                <img src={puppyImage} alt="Puppy" className="footer-image" />
                <Typography variant="body2">&copy; 2025 Preston Percival. All rights reserved.</Typography>
            </Box>
        </div>
    );
};

const App: React.FC = () => {
    const [jwt, setJwt] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setJwt(token);
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const handleLogin = (token: string) => {
        setJwt(token);
        localStorage.setItem('token', token);
        navigate('/retrieve-message');
    };

    return (
        <ThemeProvider theme={theme}>
            <Routes>
                <Route element={<AppLayout />}>
                    <Route path="/login" element={<Login onLogin={handleLogin} />} />
                    <Route path="/retrieve-message" element={<ProtectedRoute component={ProtectedMessage} />} />
                    <Route path="/add-message" element={<ProtectedRoute component={AddMessage} isAdminRoute={true} />} />
                    <Route path="*" element={<Navigate to="/retrieve-message" />} />
                </Route>
            </Routes>
        </ThemeProvider>
    );
};

const AppWrapper: React.FC = () => (
    <Router>
        <App />
    </Router>
);

export default AppWrapper;